import React from 'react';
import { Form, Input, Select, Button } from 'antd';
import './AddFournisseurForm.css'; // Ensure this is linked correctly
import { useNavigate } from 'react-router-dom'; // For navigation back
const { Option } = Select;

const AddFournisseurForm = ({ initialValues }) => {
    const navigate = useNavigate(); // Initialize navigation

    const onSubmit = (values) => {
      console.log('Submitted values:', values);
      // Handle form submission logic (e.g., save data to state or send to API)
  
      // After submission, navigate back to the fournisseurs list
      navigate('/fournisseurs');
    };
  return (
    <Form
      layout="vertical"
      onFinish={onSubmit}
      initialValues={initialValues || {}}
      className="add-fournisseur-form" // Custom class for styles
    >
        <div className='form'>
            <Form.Item
                label="RECHERCHER LE MEMBRE PAR SON NUMÉRO CCAP"
                name="ccap"
                className="form-item" // For consistent styling
            >
                <Input placeholder="Numéro CCAP" className="input-field" />
            </Form.Item>

      <div className="form-row">
        <Form.Item
          label="Sélectionner le membre"
          name="membre"
          className="form-item col-6"
        >
          <Select placeholder="Choix du membre" className="select-field">
            <Option value="membre1">Membre 1</Option>
            <Option value="membre2">Membre 2</Option>
          </Select>
        </Form.Item>
        
        <Form.Item
          label="Prénom"
          name="prenom"
          className="form-item col-6"
        >
          <Input placeholder='prénom' className="input-field" />
        </Form.Item>
      </div>

      <div className="form-row">
        <Form.Item
          label="Nom"
          name="nom"
          className="form-item col-6"
        >
          <Input placeholder='nom'  className="input-field" />
        </Form.Item>
        
        <Form.Item
          label="Grade"
          name="grade"
          className="form-item col-6"
        >
          <Input placeholder='grade' className="input-field" />
        </Form.Item>
      </div>

      <div className="form-row">
        <Form.Item
          label="Bénéficiaire"
          name="beneficiaire"
          className="form-item col-6"
        >
          <Input placeholder='bénéficiaire' className="input-field" />
        </Form.Item>
        
        <Form.Item
          label="Lien de parenté"
          name="lienParente"
          className="form-item col-6"
        >
          <Select placeholder="Lien de parenté" className="select-field">
            <Option value="parent">Parent</Option>
            <Option value="enfant">Enfant</Option>
          </Select>
        </Form.Item>
      </div>
      
        <Form.Item className="button-group">
        <div className="form-row ">
            <Button
            type="primary"
            htmlType="submit"
            className="submit-button"
            >
            {initialValues ? 'Modifier la ligne' : 'Ajouter la ligne'}
            </Button>
            <Button
            className="cancel-button"
            onClick={() => navigate('/fournisseurs')}
            >
            Annuler
            </Button>
            </div>
        </Form.Item>
        </div>
      
    </Form>
  );
};

export default AddFournisseurForm;
